import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ExhibitLabel from "./ExhibitLabel";
import FearOrigin from "./FearOrigin";
import FearScale from "./FearScale";
import FearSymptoms from "./FearSymptoms";
import MuseumMap from "./MuseumMap";
import QuotePanel from "./QuotePanel";
import ReflectionPrompt from "./ReflectionPrompt";
import RoomAtmosphere from "./RoomAtmosphere";

function FearRoom({ fear }) {
  return (
    <article className="mx-auto w-full max-w-7xl px-5 py-12 lg:px-8 lg:py-16">
      <Link to="/#gallery" className="mb-8 inline-flex items-center gap-2 text-sm text-museum-muted transition hover:text-museum-gold">
        <ArrowLeft size={16} aria-hidden="true" />
        Return to Gallery
      </Link>
      <div className="grid gap-9 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        <div className="space-y-6">
          <div>
            <p className="text-xs uppercase tracking-[0.32em] text-museum-gold">{fear.name}</p>
            <h1 className="mt-4 font-display text-5xl leading-tight text-balance text-museum-bone sm:text-6xl">{fear.roomName}</h1>
            <p className="mt-5 text-xl leading-8 text-museum-muted">{fear.tagline}</p>
          </div>
          <ExhibitLabel fear={fear} />
          <section className="rounded-lg border border-museum-bone/12 bg-museum-black/45 p-5">
            <h2 className="font-display text-2xl text-museum-bone">Inside this room</h2>
            <div className="mt-4 grid gap-3 text-sm leading-6 text-museum-muted sm:grid-cols-2">
              <p>A visual atmosphere that gives the fear a shape.</p>
              <p>A human description of how it can feel.</p>
              <p>A simple explanation of why the signal may exist.</p>
              <p>A private scale and reflection questions for distance.</p>
            </div>
          </section>
          <MuseumMap category={fear.category} />
        </div>
        <RoomAtmosphere type={fear.atmosphere} />
      </div>
      <div className="mt-12 grid gap-6 lg:grid-cols-[1fr_0.82fr]">
        <div className="space-y-6">
          <section className="glass-panel rounded-lg p-6">
            <h2 className="font-display text-3xl text-museum-bone">What it feels like</h2>
            <p className="mt-4 leading-8 text-museum-muted">{fear.whatItFeelsLike}</p>
          </section>
          <FearOrigin text={fear.whyItExists} />
          <FearSymptoms signs={fear.commonSigns} />
          <FearScale />
          <ReflectionPrompt questions={fear.reflectionQuestions} />
        </div>
        <div className="space-y-6">
          <QuotePanel quote={fear.quote} />
          <section className="rounded-lg border border-museum-bone/12 bg-museum-black/45 p-6">
            <h2 className="font-display text-2xl text-museum-bone">Grounding note</h2>
            <p className="mt-4 leading-8 text-museum-muted">
              If this fear feels overwhelming in real life, consider talking to someone you trust or a qualified professional.
            </p>
          </section>
        </div>
      </div>
    </article>
  );
}

export default FearRoom;
